import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { tenantApi } from '../api/tenantApi';

/** Tenant directory, fetched only for callers allowed to read it. */
export function useTenants(enabled = true) {
	return useQuery({
		queryKey: queryKeys.tenants.list(),
		queryFn: ({ signal }) => tenantApi.list(signal),
		enabled,
		retry: false,
		staleTime: 5 * 60_000,
	});
}
